import config, { EnvironmentNames } from './global/constants';
import addGlobal from './global/addGlobal';

const app = addGlobal('#tuition_enroll');

if (config.env === EnvironmentNames.local) {
  app.config.performance = true;
}
